<template>
  <div class="dborder dinline-block vtop tcenter br8" :style="{backgroundImage:'url('+item.image+')',backgroundPosition:'0 0',backgroundRepeat:'no-repeat'}">
    <div class="lh16">{{item.title}}</div>
  </div>
</template>

<script>
export default {
  name: "school-tag",
  props: [
    'index',
    'item',
  ],
}
</script>

<style scoped>
  .mcollege-wrap .college .dborder{margin: 0 2px 9px;padding-top: 115px;width: 180px;height: 170px;}
  .mcollege-wrap .college .dborder:hover{background-color: #e0e9f5;color: #063674;border-color: transparent;}
</style>



// WEBPACK FOOTER //
// src/components/main/about/school-tag.vue